export const FooterData = [
    {
        title: "Links",
        links: [
            {
                title: "Home",
                url: "/",
                cName: "footer-links",
                icon: "fa-solid fa-house-user"
            },
            {
                title: "About Me",
                url: "/about",
                cName: "footer-links",
                icon: "fa-solid fa-address-card"
            },
            {
                title: "Portfolio",
                url: "/projects",
                cName: "footer-links",
                icon: "fa-solid fa-pen-to-square"
            },
        ]
    },
    {
        title: "Find Me Elsewhere",
        links: [
            {
                title: "Github",
                url: "https://github.com/duskuser",
                cName: "footer-links",
                icon: "fa-brands fa-github"
            },
            {
                title: "Instagram",
                url: "https://www.instagram.com/duskuser/",
                cName: "footer-links",
                icon: "fa-brands fa-instagram"
            },
        ]
    }
]